class VariantContents extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.contents = this.querySelectorAll('.variant-contents');
    document.addEventListener('variant:change', (event) => {
      this.updateContents(event);
    });
  }

  updateContents(event) {
    const variant = event.detail.variant;
    this.contents.forEach((content) => {
      const contentId = content.getAttribute('data-variant-id');
      if (parseInt(contentId) === variant.id) {
        content.classList.remove('hidden');
      } else {
        content.classList.add('hidden');
      }
    });
  }
}

if (!window.customElements.get('variant-contents')) {
  window.customElements.define('variant-contents', VariantContents);
}
